import {
    CLASSIFICATIONS as CONSENT_CLASSIFICATIONS,
    CLASSIFICATION_LABELS as CONSENT_CLASSIFICATION_LABELS,
} from '../Classification.constants';

import { translate } from '/b2b/common/helpers/i18n';

const UNKNOWN = 'UNKNOWN';
const UNSAVED = 'UNSAVED';
const { HIDDEN } = CONSENT_CLASSIFICATIONS;

const makeTranslator = lookup => value => translate(lookup[value] || value);

// Classifications
export const CLASSIFICATIONS = {
    ...CONSENT_CLASSIFICATIONS,
    UNKNOWN,
};

export const CLASSIFICATION_LABELS = {
    ...CONSENT_CLASSIFICATION_LABELS,
    [UNKNOWN]: 'common.fields.classifications.unknown',
};

export const translateClassification = makeTranslator(CLASSIFICATION_LABELS);

// Disclosed Status
export const DISCLOSED = 'Disclosed';
const UNDISCLOSED = 'Undisclosed';

export const DISCLOSED_STATUSES = {
    [DISCLOSED]: true,
    [UNDISCLOSED]: false,
};

export const DISCLOSED_LABELS = {
    [DISCLOSED]: 'components.Classification.filters.disclosed',
    [UNDISCLOSED]: 'components.Classification.filters.undisclosed',
};

export const translateDisclosed = makeTranslator(DISCLOSED_LABELS);

// Published Status
export const PUBLISHED = 'Published';
const UNPUBLISHED = 'Unpublished';

export const PUBLISHED_STATUSES = {
    [PUBLISHED]: true,
    [UNPUBLISHED]: false,
};

const PUBLISHED_LABELS = {
    [PUBLISHED]: 'components.Classification.filters.published',
    [UNPUBLISHED]: 'components.Classification.filters.unpublished',
};

export const translatePublished = makeTranslator(PUBLISHED_LABELS);

export const SAVED = 'Saved';

// Display Status
export const DISPLAY_STATUS_LABELS = {
    [PUBLISHED]: PUBLISHED_LABELS[PUBLISHED],
    [SAVED]: PUBLISHED_LABELS[UNPUBLISHED],
    [UNSAVED]: 'components.Classification.unsaved',
};

export const translateDisplayStatus = makeTranslator(DISPLAY_STATUS_LABELS);

const classificationValues = Object.values(CLASSIFICATIONS);

const mapClassification = classification => ({
    value: classification,
    label: CLASSIFICATION_LABELS[classification],
});

const mapClassificationOptionLabels = ({ label }) => label;

export const CLASSIFICATION_VIEWS = {
    DISCOVERIES: 'discoveries',
    RULES: 'rules',
    IGNORED: 'ignored',
};

export const classificationOptions = {
    [CLASSIFICATION_VIEWS.RULES]: classificationValues
        .filter(classification => classification !== HIDDEN && classification !== UNKNOWN)
        .map(mapClassification),
    [CLASSIFICATION_VIEWS.DISCOVERIES]: classificationValues
        .filter(classification => classification !== HIDDEN)
        .map(mapClassification),
    [CLASSIFICATION_VIEWS.IGNORED]: classificationValues
        .filter(classification => classification !== UNKNOWN)
        .map(mapClassification),
};

export const classificationFilterLabels = {
    [CLASSIFICATION_VIEWS.RULES]: classificationOptions[CLASSIFICATION_VIEWS.RULES].map(
        mapClassificationOptionLabels
    ),
    [CLASSIFICATION_VIEWS.DISCOVERIES]: classificationOptions[CLASSIFICATION_VIEWS.RULES].map(
        mapClassificationOptionLabels
    ),
    [CLASSIFICATION_VIEWS.IGNORED]: classificationOptions[CLASSIFICATION_VIEWS.RULES].map(
        mapClassificationOptionLabels
    ),
};

export const confidenceColorMap = {
    high: 'success',
    medium: 'warning',
    low: 'error',
    none: 'none',
};

export const confidenceColorForPercent = percent => {
    if (percent >= 80) {
        return confidenceColorMap.high;
    }
    if (percent >= 50) {
        return confidenceColorMap.medium;
    }
    if (percent >= 0) {
        return confidenceColorMap.low;
    }
    return 'none';
};

export const REVIEW_STATES = {
    // No discoveries to review
    COMPLETE: 'COMPLETE',
    // User got to end of list, but skipped some discoveries
    END_OF_LIST: 'END_OF_LIST',
    // User got to end of filtered/searched list, but more exist if filters are cleared
    FILTERED_END_OF_LIST: 'FILTERED_END_OF_LIST',
};
